<template>
  <div class="jl-login">
    <v-login-register :isLogin="false"></v-login-register>
  </div>
</template>

<script>
import Login_Register from "@/components/Login_Register";
export default {
  name: "register",
  components: {
    "v-login-register": Login_Register
  },
  data() {
    return {
      isShowPassword: false
    };
  }
};
</script>